module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-arrow-down-fill-7e401c4b.svg";